module.exports = __webpack_public_path__ + "img/media-pg-image-1.ea06dcb2.jpg";